import { GOAL_TYPES } from './types.js';
/** Ziele, die die Runde zurück zum Startflughafen führen. */
const RETURNS_TO_START = new Set([
    'world_east',
    'world_west',
    'europe_countries',
    'top_islands',
    'antipode_world',
]);
/** Ohne Doppelte und in fester Reihenfolge – so heißt dieselbe Kombination überall gleich. */
export function normalizeGoalTypes(types) {
    const chosen = new Set(types);
    return GOAL_TYPES.filter((g) => chosen.has(g));
}
/**
 * Lässt sich diese Auswahl gemeinsam erfüllen? `null` heißt ja.
 * Antipoden enden am anderen Ende der Welt, freies Fliegen hat kein Ziel –
 * beide passen zu nichts anderem.
 */
export function goalCombinationError(types) {
    const set = new Set(types);
    if (set.size === 0)
        return 'empty';
    if (set.has('world_east') && set.has('world_west'))
        return 'east_west';
    if (set.has('antipode') && set.size > 1)
        return 'antipode_alone';
    if (set.has('free') && set.size > 1)
        return 'free_alone';
    return null;
}
/** Endet die Runde am Start? Dann ist ein eigener Zielflughafen bedeutungslos. */
export function returnsToStart(types) {
    return types.some((g) => RETURNS_TO_START.has(g));
}
/** X eines Top-Ziels; Runden von vor der Kombination kennen nur das gemeinsame `topX`. */
export function topXFor(options, goal) {
    const own = goal === 'top_islands' ? options.topXIslands : options.topXAirlines;
    return own ?? options.topX;
}
//# sourceMappingURL=goals.js.map